import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import {
  DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION,
  DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import onlineVehicleRegistration from '../../../../api/bank/online-vehicle-registration';

const UploadAdditionalDocuments = ({
  backHandler,
  loading,
  deal,
  chosenBankAppealId,
  setLoading,
  onSuccess,
  bankId,
}) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();

  const onNotarialDocumentsSubmit = async (values) => {
    // if (!values['customsClearanceConfirmation']) {
    //   alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ');
    //   return;
    // }

    if (!values['extendedProducerResponsibilityConfirmation']) {
      alert.error(
        'ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸ (Ð¸Ð¼Ð¿Ð¾ÑÑÐµÑÐ°Ð¼Ð¸)'
      );
      return;
    }

    const filesToUpload = [
      values['customsClearanceConfirmation'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION,
        file: values['customsClearanceConfirmation'],
      },
      values['extendedProducerResponsibilityConfirmation'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
        file: values['extendedProducerResponsibilityConfirmation'],
      },
    ].filter(Boolean);

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);

      onlineVehicleRegistration(deal?.chunkId)
        .then(() => {
          onSuccess(values);
        })
        .catch(() => {
          alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² (online-vehicle-registration)');
          setLoading(false);
        });
    } catch (err) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        hint="ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼ÑÐµ Ð¿ÑÐ¸ Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¹ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾"
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸ (Ð¸Ð¼Ð¿Ð¾ÑÑÐµÑÐ°Ð¼Ð¸)',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'extendedProducerResponsibilityConfirmation',
            id: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸ (Ð¸Ð¼Ð¿Ð¾ÑÑÐµÑÐ°Ð¼Ð¸)',
            component: DocsInputNew,
          },
          {
            text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'customsClearanceConfirmation',
            id: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ',
            component: DocsInputNew,
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default UploadAdditionalDocuments;
